export default function () {
  function fixHeight() {
    let wrap = document.querySelector(".tabs__wrapper");
    let tabs = document.querySelectorAll(".tab img");
    if (tabs.length == 0 || wrap.length == 0) {
      return;
    }
    let hi = 0;
    for (let i = 0; i < tabs.length; i++) {
      const element = tabs[i];
      if (element.clientHeight > hi) {
        hi = element.clientHeight;
      }
    }
    wrap.setAttribute("style", `height:${hi}px`);
  }

  function handleTabSwitch() {
    let switches = document.querySelectorAll("[data-toggle-tab]");
    let tabs = document.querySelectorAll(".tab");
    if (switches.length == 0) {
      return;
    }
    switches[0].classList.add("active");
    tabs[0].classList.add("active");

    for (let i = 0; i < switches.length; i++) {
      const element = switches[i];
      element.addEventListener("click", function () {
        let t = element.getAttribute("data-toggle-tab");

        for (let j = 0; j < switches.length; j++) {
          const element = switches[j];
          element.classList.remove("active");
        }

        for (let j = 0; j < tabs.length; j++) {
          const element = tabs[j];
          element.classList.remove("active");
        }
        console.log(t);

        element.classList.add("active");
        tabs[t].classList.add("active");
      });
    }
  }

  handleTabSwitch();
  setTimeout(() => {
  fixHeight();
  }, 500);
  setTimeout(() => {
	fixHeight();
	}, 1500);
}
